import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";

import * as wcApi from "../../../services/wcApi";

import PaymentTypes from "../../../enums/PaymentTypes";
import FormSelect from "../../UI/FormSelect";
import { CircularProgress, LinearProgress } from "@material-ui/core";
import { classes } from "istanbul-lib-coverage";

const useStyles = makeStyles(theme => ({
  clickable: {
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#F5F5F5"
    }
  }
}));

export default function PaymentMethodField({ customer, onCustomerUpdated }) {
  const classes = useStyles();
  const [editMode, setEditMode] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [currentOption, setCurrentOption] = useState(customer.payment_method);

  const optionKeys = Object.keys(PaymentTypes);
  const optionValues = optionKeys.map(key => PaymentTypes[key]);

  async function handleChange(selectedValue) {
    const index = optionValues.findIndex(value => value === selectedValue);
    if (index < 0) return;

    const newPaymentMethod = optionKeys[index];

    setIsSaving(true);
    const payload = {
      meta_data: [
        {
          key: "payment_method",
          value: newPaymentMethod
        }
      ]
    };
    const result = await wcApi.updateCustomer(customer.id, payload);
    onCustomerUpdated(result.data);
    setCurrentOption(newPaymentMethod);
    setEditMode(false);
    setIsSaving(false);
  }

  function paymentMethod() {
    if (customer.payment_method && customer.payment_method in PaymentTypes) {
      return PaymentTypes[customer.payment_method];
    }

    return "Not Set";
  }

  // Find Default
  let selectedValue = null;
  if (currentOption) {
    const index = optionKeys.findIndex(option => option === customer.payment_method);
    if (index >= 0) {
      selectedValue = optionValues[index];
    }
  }

  if (editMode) {
    return (
      <div>
        <b>Payment Method:</b>{" "}
        <FormSelect
          small
          values={optionValues}
          initialValue={selectedValue}
          onChange={handleChange}
          fullWidth={false}
        />
      </div>
    );
  } else {
    return (
      <div onClick={() => setEditMode(true)} className={classes.clickable}>
        <div>
          <strong>Payment Method:</strong> {paymentMethod()}
        </div>
        {isSaving && <LinearProgress />}
      </div>
    );
  }
}
